import {
    Icon,
    Icons,
    Stack,
    Heading,
    ThemeFontSizeVariable,
    ThemeIconSizeVariable,
} from "@caspeco/casper-ui-library";
import { PhoneNumberLink } from "components/links/phone-number-link";
import { useTranslation } from "react-i18next";

export function CancelBookingFailed() {
    const { t } = useTranslation();
    return (
        <Stack alignItems="flex-start">
            <Icon
                alignSelf="center"
                icon={Icons.SlightlySad}
                color="inherit"
                size={ThemeIconSizeVariable.X3Large}
            />
            <Heading
                as="h1"
                textAlign="left"
                color="inherit"
                fontSize={ThemeFontSizeVariable.XLarge}
            >
                {t("errorInformation.somethingWrong")}
            </Heading>
            <PhoneNumberLink color="inherit" />
        </Stack>
    );
}
